
    import './styles.scoped.css';
    export default {
  "expandable-toggle-wrapper": "awsui_expandable-toggle-wrapper_c6tup_ah310_97",
  "body-cell": "awsui_body-cell_c6tup_ah310_105",
  "body-cell-content": "awsui_body-cell-content_c6tup_ah310_113",
  "expandable-level-0": "awsui_expandable-level-0_c6tup_ah310_116",
  "expandable-level-1": "awsui_expandable-level-1_c6tup_ah310_119",
  "expandable-level-2": "awsui_expandable-level-2_c6tup_ah310_122",
  "expandable-level-3": "awsui_expandable-level-3_c6tup_ah310_125",
  "expandable-level-4": "awsui_expandable-level-4_c6tup_ah310_128",
  "expandable-level-5": "awsui_expandable-level-5_c6tup_ah310_131",
  "expandable-level-6": "awsui_expandable-level-6_c6tup_ah310_134",
  "expandable-level-7": "awsui_expandable-level-7_c6tup_ah310_137",
  "expandable-level-8": "awsui_expandable-level-8_c6tup_ah310_140",
  "expandable-level-9": "awsui_expandable-level-9_c6tup_ah310_143",
  "expandable-level-next": "awsui_expandable-level-next_c6tup_ah310_146",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_ah310_163",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_ah310_177",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_ah310_189",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_ah310_225",
  "body-cell-interactive": "awsui_body-cell-interactive_c6tup_ah310_225",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_ah310_225",
  "has-striped-rows-sticky-cell-pad-inline-start": "awsui_has-striped-rows-sticky-cell-pad-inline-start_c6tup_ah310_297",
  "has-selection": "awsui_has-selection_c6tup_ah310_333",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_ah310_376",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_ah310_379",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_ah310_379",
  "has-footer": "awsui_has-footer_c6tup_ah310_379",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_ah310_389",
  "sticky-cell": "awsui_sticky-cell_c6tup_ah310_417",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_ah310_425",
  "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_c6tup_ah310_475",
  "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_c6tup_ah310_484",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_ah310_517",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_ah310_523",
  "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_ah310_549",
  "body-cell-success": "awsui_body-cell-success_c6tup_ah310_556",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_ah310_549",
  "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_ah310_583",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_ah310_592",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_ah310_602",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_ah310_612",
  "body-cell-editor-row-editor": "awsui_body-cell-editor-row-editor_c6tup_ah310_615",
  "body-cell-expandable": "awsui_body-cell-expandable_c6tup_ah310_618",
  "resizable-columns": "awsui_resizable-columns_c6tup_ah310_639",
  "expandable-cell-content": "awsui_expandable-cell-content_c6tup_ah310_642",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_ah310_711",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_ah310_711"
};
  